export enum CurrencyEnum {
  ARS = 'ARS', AUS = 'AUS', CAD = 'CAD', COP = 'COP', MXN = 'MXN', NZD = 'NZD', USD = 'USD', UYU = 'UYU',
  EURO = 'EURO',
  DOLLAR = 'DOLLAR',
  GBP = 'GBP',
  UAH = 'UAH', // ₴
	INR = 'INR', // ₹
	RUB = 'RUB', // ₽
	BYN = 'BYN', // Br
	RSD = 'RSD', // Din
	HUF = 'HUF', // Ft
	DKK = 'DKK', NOK = 'NOK', SEK = 'SEK', // Kr
	RON = 'RON', // L
	ZAR = 'ZAR', // R
	BRL = 'BRL', // R$
	PLN = 'PLN', // zł
	MKD = 'MKD', // ден
	BAM = 'BAM', // KM
	BGN = 'BGN', // лв
  JPY = 'JPY', // ¥
	CHF = 'CHF', // ₣
	EUR = 'EUR', // €
}
